import { render, staticRenderFns } from "./elevatorPortray.vue?vue&type=template&id=323a57dc&"
import script from "./elevatorPortray.vue?vue&type=script&lang=js&"
export * from "./elevatorPortray.vue?vue&type=script&lang=js&"
import style0 from "./elevatorPortray.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports